import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import * as CuentaContableService from 'services/cuentaContable.service'

const CuentaDestinoFormGroup = ({ iError, iTouched, fIsSubmitting, handleChange, updateStore, rowIndex }) => {
  const [cuentasContables, setCuentaContable] = React.useState([])

  const onChange = React.useCallback(
    e => {
      handleChange(e)
      setTimeout(() => {
        updateStore()
      }, 150)
    },
    [handleChange, updateStore]
  )

  React.useEffect(() => {
    CuentaContableService.getCuentasContablesParaCAsSelect()
      .then(({ data }) => {
        setCuentaContable(data)
      })
      .catch(() => setCuentaContable([]))
  }, [])

  return (
    <Form.Group>
      <Col md={12}>
        <Field name='cuentaDestino'>
          {({ field }) => (
            <Form.Select
              {...field}
              id={`select-cuentaDestino-${rowIndex}`}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onChange={onChange}
            >
              <option value=''>Seleccionar</option>
              {cuentasContables.map((x, k) => (
                <option key={k} value={x.value}>
                  {x.label}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaDestinoFormGroup)
